import get from 'lodash.get';
export default function getErrorDetail(error) {
    const graphQLErrors = get(error, 'graphQLErrors', []);
    const codes = graphQLErrors
        .map(error => get(error, 'extensions.code'))
        .filter(Boolean);
    const data = graphQLErrors
        .map(error => get(error, 'extensions.data'))
        .filter(Boolean);
    return { codes, data };
}
//# sourceMappingURL=getErrorDetail.js.map